import './stockstemplaterow.css'
import React from 'react'

import { Delete} from "@mui/icons-material"
import StatusContext from '../../../contexts/StatusContext'
import { AlertDialog } from '../alertdialog/AlertDialog'
import {useState} from "react";

export const StocksTemplateRow = ({ chat, deleteHandler, clickHandler, setExpand, setTemplateName}) => {
    
    const [openDialog, handleDisplay] = useState(false);
    const [dialogtext, setDialogText] = useState('');

    let {
        changeLanguageEnglish,
      } = React.useContext(StatusContext);
    
    
    const alertYes = () => {
        closeDialogBox()
       deleteHandler(chat)
      }

      const alertCancel = () => {
        console.log("Chat:")
        closeDialogBox()
      }

      const openDialogBox = () => {
        handleDisplay(true);
     };
      const closeDialogBox = () => {
        handleDisplay(false);
     };

     const handleDelete = () => {
        console.log("handle Delete:", chat)

        setDialogText(`${changeLanguageEnglish('status', 'deletetopic')} '${chat.name}'?`)
      
        openDialogBox()
       
    }

    return (
        <div className="templateListItem" key={chat.id}>

            <Delete  className="promptIcon" onClick={() => { handleDelete() }} />

            <li
                className="templateName" 
                onClick={() => { clickHandler(chat);  setExpand(); setTemplateName(chat.name) }}>
                {chat.name}
            </li>

            <AlertDialog alertYes={alertYes} alertCancel={alertCancel} openDialog = {openDialog} closeDialog = {closeDialogBox} prompt={dialogtext}/>
        </div>
    )
}